import React from 'react';

/**
 * Renders a comment / rumour body with any run of >=4 X's rendered as a
 * whiteout redaction strip. Ryan types `XXXX` in the admin editor when he
 * wants a name blacked out; the client turns each XXXX+ into a raised
 * whited-out bar so it looks like a physical redaction on the page.
 *
 * - Case-insensitive (`xxxx` works too).
 * - Preserves the number of X's so a long name stays a long strip.
 * - Uses inline-block with negative letter-spacing so the width mirrors
 *   the count without a fragile width-per-character calc.
 * - Wraps in <span data-redacted /> so it survives inside <p>/pre-wrap and
 *   can be styled globally.
 */
const REDACT = /X{4,}/gi;

const Redacted = ({ text, testId }) => {
  if (!text) return null;
  const parts = [];
  let last = 0;
  let m;
  REDACT.lastIndex = 0;
  while ((m = REDACT.exec(text)) !== null) {
    if (m.index > last) parts.push({ t: 'text', v: text.slice(last, m.index) });
    parts.push({ t: 'redact', v: m[0] });
    last = m.index + m[0].length;
  }
  if (last < text.length) parts.push({ t: 'text', v: text.slice(last) });

  return (
    <span data-testid={testId}>
      {parts.map((p, i) =>
        p.t === 'text' ? (
          <React.Fragment key={i}>{p.v}</React.Fragment>
        ) : (
          <span
            key={i}
            data-redacted="1"
            aria-label="redacted"
            title="Redacted"
            className="outlaw-redact"
          >
            {p.v}
          </span>
        ),
      )}
    </span>
  );
};

export default Redacted;
